export default {
  suggestions: {
    marginTop: '30px',
    zIndex: 999, // Prevents mentioned user compnents to appear in front of the mention suggestions list
    list: {
      borderRadius: 8,
      boxShadow: '0 2px 6px 0 rgba(0, 0, 0, 0.3)',
      maxHeight: 285,
      overflowY: 'scroll',
      width: 320,
      top: 2
    },

    item: {
      padding: '6px 16px',
      fontWeight: 600,
      '&focused': {
        backgroundColor: '#f4f4f4'
      }
    }
  }
};
